// config.js

let APIUrl;
let FileManagerUrl;
let IsEncrypted;

// If you want to run the application on a different server, please uncomment and comment other for server
const server = window.location.hostname;
// const server = 'dev.shipcrm.org'; //DEV API
// const server = 'shipcrm.org'; //LIVE API

// http://192.168.1.243:8080/onchange-handler/save
switch (server) {
    case 'localhost': // Local development
        APIUrl = 'http://localhost:8080/'; 
        FileManagerUrl = 'http://localhost:8001/';
        IsEncrypted = false;
        break;

    case 'dev.shipcrm.org': // Development environment
        APIUrl = process.env.REACT_APP_DEVELOPMENT_API_URL; 
        FileManagerUrl = process.env.REACT_APP_DEVELOPMENT_FILE_MANAGER_URL; 
        IsEncrypted = true;
        break;
     
    case 'uat.shipcrm.org': // UAT environment
        APIUrl = process.env.REACT_APP_UAT_API_URL; 
        FileManagerUrl = process.env.REACT_APP_UAT_FILE_MANAGER_URL;
        IsEncrypted = true;
        break;

    case 'shipcrm.org': // Production environment
        APIUrl = process.env.REACT_APP_PRODUCTION_API_URL; 
        FileManagerUrl = process.env.REACT_APP_PRODUCTION_FILE_MANAGER_URL;
        IsEncrypted = true;
        break;
    default:
        APIUrl = process.env.REACT_APP_PRODUCTION_API_URL;
        FileManagerUrl = process.env.REACT_APP_PRODUCTION_FILE_MANAGER_URL;
        IsEncrypted = true;
        break;
}

// Export the URLs
export { APIUrl, IsEncrypted, FileManagerUrl };
